import axios from "axios";

const appEndPoint = process.env.REACT_APP_BACKEND_ENDPOINT;

const api = axios.create({
  baseURL: appEndPoint,
});

export default api;
